import { Box, Button, useDisclose } from 'native-base';
import React from 'react';

import TicketCarouselModal from 'app/components/TicketCarouselModal';
import { ProductType } from 'app/generated/hygraph';
import { useI18n } from 'app/providers/I18nProvider';
import { Entitlement } from 'app/services/GuestCenterService.types';
import { tID } from 'app/services/TestHelper';

export type AttractionSupportInfoProps = {
  entitlement: Maybe<Entitlement>;
  productContentKey: Maybe<string>;
  productType: Maybe<ProductType>;
  attractionOffline?: boolean;
};

export default function AttractionSupportInfo({
  entitlement,
  productContentKey,
  productType,
  attractionOffline = false,
}: AttractionSupportInfoProps) {
  const { t } = useI18n();
  const { isOpen, onClose, onOpen } = useDisclose();

  const passes = entitlement?.passes;
  const orderNumber = entitlement?.travelParty?.orderNumber;
  const shouldRender =
    !!entitlement &&
    !!passes &&
    productContentKey === entitlement?.productContentKey &&
    productType !== ProductType.Alacarte;

  if (!shouldRender) return null;

  return (
    <Box testID={tID('AttractionSupportInfo')}>
      <Button
        onPress={onOpen}
        {...(!attractionOffline
          ? {
              _text: {
                color: 'gray.400',
                textDecorationColor: 'gray.400',
                fontWeight: 'normal',
              },
              _web: {
                _light: {
                  shadow: '0 !important',
                },
              },
              color: '#ccc',
              shadow: 0,
              variant: 'link',
            }
          : {})}
      >
        {!attractionOffline
          ? t('app_attraction_support_info') || 'Attraction staff support information'
          : t('app_view_citypass_tickets') || 'View My CityPASS Tickets'}
      </Button>

      <TicketCarouselModal
        isOpen={isOpen}
        orderNumber={orderNumber}
        passes={passes}
        onClose={onClose}
      />
    </Box>
  );
}
